import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, useContext } from 'react';

import { keysToCamel } from '@utils/butter';

import FlowContext from '@providers/FlowContextProvider';

import { IFlowStepProps } from '@folx-types/flow-steps';

import MemberEstrogenOtherMedicationStep, {
	IMemberEstrogenOtherMedicationStepPageContent,
} from './MemberEstrogenOtherMedicationStep.component';

interface IMemberEstrogenOtherMedicationStepPageProps extends IFlowStepProps {}

const MemberEstrogenOtherMedicationStepPage: FC<IMemberEstrogenOtherMedicationStepPageProps> = ({
	path,
	stepKey,
}) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "member-estrogen-other-medication-step" }) {
				page_header
				page_info
				medication_header
				spironolactone {
					title
					description
				}
				finasteride {
					title
					description
				}
				dutasteride {
					title
					description
				}
				progesterone {
					title
					description
				}
				unsure {
					title
					description
				}
			}
		}
	`);

	const { existingFormData, handleFormSubmission, handleNavBack } = useContext(FlowContext);

	const refinedContent: IMemberEstrogenOtherMedicationStepPageContent = keysToCamel(
		pageContent
	) as IMemberEstrogenOtherMedicationStepPageContent;

	return (
		<MemberEstrogenOtherMedicationStep
			pageContent={refinedContent}
			path={path}
			stepKey={stepKey}
			existingFormData={existingFormData}
			handleFormSubmission={handleFormSubmission}
			handleNavBack={handleNavBack}
		/>
	);
};

export default MemberEstrogenOtherMedicationStepPage;
